/* eslint-disable react/require-default-props */
import React from "react";

import { Modal } from "antd";

import * as S from "./style";
import { ConfirmationModalProps } from "./types";

export function ConfirmationModal({
  description,
  isLoading,
  onClose,
  onSubmit,
  title,
  cancelText = "Cancelar",
  submitText = "Confirmar",
  cancelDataTestId,
  submitDataTestId,
  closeDataTestId,
}: ConfirmationModalProps) {
  const handleClose = () => {
    if (isLoading) {
      return;
    }

    onClose();
  };
  return (
    <Modal
      title={<span style={{ fontWeight: "bold" }}>{title}</span>}
      open
      closable={!isLoading}
      maskClosable={!isLoading}
      onCancel={handleClose}
      style={{
        borderRadius: "8px",
      }}
      closeIcon={closeDataTestId ? <span data-testid={closeDataTestId}>X</span> : undefined}
    >
      <S.Container>
        <S.TitleWrapper>
          <S.Title>{description}</S.Title>
        </S.TitleWrapper>
        <S.ButtonWrapper>
          <S.CancelButton
            onClick={onClose}
            disabled={isLoading}
            data-testid={cancelDataTestId}
          >
            {cancelText}
          </S.CancelButton>

          <S.UpdateDomainButton
            onClick={onSubmit}
            disabled={isLoading}
            data-testid={submitDataTestId}
          >
            {isLoading && <S.Loader data-testid="loader" />} {submitText}
          </S.UpdateDomainButton>
        </S.ButtonWrapper>
      </S.Container>
    </Modal>
  );
}
